import React, { useMemo, useEffect } from 'react';
import { Th, HStack, chakra } from '@chakra-ui/react';
import { FilterColumnInput } from './utils/input-filters.js';
import { IndeterminateCheckbox } from './utils/table-utils.js';
import { i18n } from '../../../i18n/translate.js';
import { Icon } from '../Icon/component.js';

var CoreTableHeaderCell = function CoreTableHeaderCell(_ref) {
  var _header$column, _column$width;

  var header = _ref.header,
      table = _ref.table,
      select = _ref.select,
      index = _ref.index,
      tableOptions = _ref.tableOptions,
      dataListProps = _ref.dataListProps;
  /**
   * DOM
   */

  var column = header.column.columnDef;
  var cell = useMemo(function () {
    var header = column.title ? column.title : column.header;

    if (typeof header === 'string') {
      return header;
    }

    return header(column);
  }, [column]);
  var canSort = column.sort || column.canSort;
  var attrTxt = i18n.t('%s sortable', {
    postProcess: 'sprintf',
    sprintf: [column.title]
  });
  var ColumnFilter = ((_header$column = header.column) === null || _header$column === void 0 || (_header$column = _header$column.columnDef) === null || _header$column === void 0 || (_header$column = _header$column.meta) === null || _header$column === void 0 ? void 0 : _header$column.filterComponent) || FilterColumnInput;
  var isLoadingData = dataListProps.isLoadingData,
      selectRow = dataListProps.selectRow;
  useEffect(function () {
    // sorting foundry table data
    if (header.column.getIsSorted() && tableOptions && tableOptions.onSortChange) {
      tableOptions.onSortChange(header.id, header.column.getIsSorted());
    }
  }, [header.column.getIsSorted()]);

  var selectAllHandler = function selectAllHandler() {
    var shouldSelectAll = !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected();
    table.toggleAllRowsSelected(shouldSelectAll);
    selectRow === null || selectRow === void 0 || selectRow.onSelectAll(shouldSelectAll);
  };

  return /*#__PURE__*/React.createElement(Th, {
    key: header.id,
    colSpan: header.colSpan,
    "aria-label": canSort && attrTxt,
    "data-object-action": canSort && "sort-".concat(column.name),
    width: (_column$width = column.width) !== null && _column$width !== void 0 ? _column$width : 'auto'
  }, /*#__PURE__*/React.createElement(HStack, null, select && index === 0 ? /*#__PURE__*/React.createElement(IndeterminateCheckbox, {
    checked: table.getIsAllRowsSelected(),
    indeterminate: table.getIsSomeRowsSelected(),
    onChange: selectAllHandler,
    isLoadingData: isLoadingData,
    selectHandler: selectRow === null || selectRow === void 0 ? void 0 : selectRow.onSelectAll,
    selectedProp: table.getIsAllRowsSelected(),
    header: true
  }) : '', canSort ? /*#__PURE__*/React.createElement("div", {
    onClick: header.column.getToggleSortingHandler()
  }, cell, /*#__PURE__*/React.createElement(chakra.span, {
    pl: "4"
  }, header.column.getIsSorted() ? header.column.getIsSorted() === 'desc' ? /*#__PURE__*/React.createElement(Icon, {
    iconName: "sort-down"
  }) : /*#__PURE__*/React.createElement(Icon, {
    iconName: "sort-up"
  }) : /*#__PURE__*/React.createElement(Icon, {
    iconName: "sort"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, cell), column.filter ? /*#__PURE__*/React.createElement(ColumnFilter, {
    column: header.column,
    table: table
  }) : null));
};

CoreTableHeaderCell.displayName = "CoreTableHeaderCell";
export { CoreTableHeaderCell };